import { ICustomList, TPermissionInfo } from '../AddToList/shared';

interface IIsUserCuratorForList {
  customList?: ICustomList;
  userId?: string;
}

/**
 * This function checks if the currently logged in user is a curator for the given list.
 */
export function isUserCuratorForList({
  customList,
  userId,
}: IIsUserCuratorForList): boolean {
  if (!customList?.permissions || !userId) {
    return false;
  }

  return customList.permissions.some(
    (permission: TPermissionInfo): boolean =>
      permission.userId === userId && permission.roles.includes('admin')
  );
}
